export enum SalesByUserDetailPeriodEnum {
  TOTAL = 'TOTAL',
  DATE_RANGE = 'DATE_RANGE',
}
